export default __webpack_public_path__ + "static/media/chocodoLight.b47036a4.png";